

































import { Component, Vue } from "vue-property-decorator";

import { render, imageMetadata } from "../coloring";

@Component({})
export default class ColorMe extends Vue {
  colors = imageMetadata.colors;
  // discarded on navigate
  newColors: number[][] = [];
  defaultColors: string = "";
  handle: number = 0;

  toHex(rgb: number[]) {
    return "#" + rgb.map(n => (n < 0x10 ? "0" : "") + n.toString(16)).join("");
  }

  created() {
    this.newColors = this.colors.map(([color, _]) =>
      (color as string).split(",").map(Number)
    );
    this.defaultColors = this.colorsToBytes().join("");
    if (this.$route.params.major) {
      this.loadColors(this.$route.params.major);
    }
  }

  get tweet() {
    let text =
      "Color the platypus! " + encodeURIComponent(window.location.href);
    return "http://twitter.com/intent/tweet?text=" + text;
  }

  sendTweet() {
    window.open(this.tweet, "_blank");
  }

  // load the large color regions from a base64url string
  loadColors(major: string) {
    let base64 = major.replace(/-/g, "+").replace(/_/g, "/");
    let binary = atob(base64);
    for (let i = 0; i < this.newColors.length && i * 3 < binary.length; i++) {
      let rgb = binary.substr(i * 3, 3);
      this.newColors[i] = [
        rgb.charCodeAt(0) || 0,
        rgb.charCodeAt(1) || 0,
        rgb.charCodeAt(2) || 0,
      ];
    }
  }

  get image() {
    return this.$refs.image as HTMLImageElement;
  }

  get container() {
    return this.$refs.container as any;
  }

  mounted() {
    this.image.onload = () => this.imageReady();
    if (this.image.complete) {
      this.imageReady();
    }
  }

  // animate
  imageReady() {
    this.update();
  }

  rerender() {
    render(
      this.$refs.image as HTMLImageElement,
      this.$refs.canvas as HTMLCanvasElement,
      this.newColors
    );
    this.handle = 0;
  }

  // throttled with requestAnimationFrame
  update() {
    if (this.handle) {
      window.cancelAnimationFrame(this.handle);
    }
    this.handle = window.requestAnimationFrame(() => {
      this.rerender();
      this.toUriFragment();
      this.container.style = "background: " + this.toHex(this.newColors[0]);
    });
  }

  changeColor(index: number, htmlColor: string) {
    let rgb = Number.parseInt(htmlColor.substring(1), 16);
    this.newColors[index] = [(rgb >> 16) & 0xff, (rgb >> 8) & 0xff, rgb & 0xff];
    this.update();
  }

  colorsToBytes() {
    let characters = [];
    for (let i = 0; i < this.newColors.length; i++) {
      for (let j = 0; j < 3; j++) {
        characters.push(String.fromCharCode(this.newColors[i][j]));
      }
    }
    return characters;
  }

  toUriFragment() {
    let characters = this.colorsToBytes().join("");

    // shorten to only the prefix that differs from the default colors
    let j = Math.min(characters.length, this.defaultColors.length) - 1;
    while (j > 0 && characters.charAt(j) == this.defaultColors.charAt(j)) {
      j--;
    }

    let truncated = characters.substring(0, j);

    let base64 = btoa(truncated)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=*$/, "");
    // it doesn't like the route if the params are falsey
    this.$router.replace({
      ...this.$route,
      name: "custom-color",
      params: { major: base64 || "=" },
    });
  }
}
